/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _3 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>3 - Генерация Id элементов формы</h2>
    <p className={styles.description}>
      <b>Доступность (accessibility, a11y)</b> - очень важная тема в современном вебе. HTML-атрибут{' '}
      <code className={styles.code}>for</code> тега <code className={styles.code}>label</code> помогает читалкам и
      другим вспомогательным инструментам. В React он представлен jsx-атрибутом{' '}
      <code className={styles.code}>htmlFor</code>.{' '}
    </p>
    <p className={styles.description}>
      Для генерации уникальных идентификаторов элементов форм используется следующий подход: для каждого экземляра
      компонента, при его инициализации, создается набор уникальных идентификаторов, ханящихся на экземпляре. Таким
      образом, между разными формами получаем уникальные id.
    </p>
    <CopyBlock
      text={`// Можно использовать любой пакет для генерации уникальных строк
import shortid from 'shortid';

class Form extends React.Component {
  loginInputId = shortid.generate();

  render() {
    return (
      <form>
        <label htmlFor={this.loginInputId}>Login</label>
        <input type="text" name="login" id={this.loginInputId} />
      </form>
    );
  }
}`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
  </section>
))
